function isResult(input) {
  return typeof input !== "function";
}
function isPromise(input) {
  return typeof input.then === "function";
}
export function resolveOptions(input) {
  if (isPromise(input)) {
    return input;
  }
  if (isResult(input)) {
    return Promise.resolve(input);
  }
  var result = input();
  if (isPromise(result)) {
    return result;
  }
  return Promise.resolve(result);
}